import { SenecFPPThemeProvider } from "@newsenec/ui-components";
import { RegistrationScreen } from "./screens/registration/RegistrationScreen";
import { EmailVerificationScreen } from "./screens/email-verification/EmailVerificationScreen";
import { RetryScreen } from "./screens/retry/RetryScreen";
import { WelcomeScreenCockpit } from "./screens/welcome/WelcomeScreenCockpit";
import { TermsApprovalScreen } from "./screens/terms-approval/TermsApprovalScreen";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { screenRoutes } from "./screenRoutes";
import { isAppControl, isCockpitItaly } from "@newsenec/auth-provider";
import { UnauthorizedScreen } from "./screens/unauthorized/UnauthorizedScreen";
import { WelcomeScreenControl } from "./screens/welcome/WelcomeScreenControl";
import { WelcomeScreenCockpitIT } from "./screens/welcome/WelcomeScreenCockpitIT";

export default function Root() {
    return (
        <SenecFPPThemeProvider>
            <Router>
                <Routes>
                    <Route path={screenRoutes.registration} element={<RegistrationScreen />} />
                    <Route path={screenRoutes.verifyEmail} element={<EmailVerificationScreen />} />
                    <Route path={screenRoutes.retry} element={<RetryScreen />} />
                    <Route
                        path={screenRoutes.welcome}
                        element={
                            isCockpitItaly() ? (
                                <WelcomeScreenCockpitIT />
                            ) : isAppControl() ? (
                                <WelcomeScreenControl />
                            ) : (
                                <WelcomeScreenCockpit />
                            )
                        }
                    />
                    <Route path={screenRoutes.termsApproval} element={<TermsApprovalScreen />} />
                    <Route path={screenRoutes.unauthorized} element={<UnauthorizedScreen />} />
                    <Route path="*" element={<Navigate to={screenRoutes.retry} replace />} />
                </Routes>
            </Router>
        </SenecFPPThemeProvider>
    );
}
